import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { CommonService } from '../../services/common/common.service';


@Component({
  selector: 'app-consent-history-filter',
  templateUrl: './consent-history-filter.component.html',
  styleUrls: ['./consent-history-filter.component.scss']
})
export class ConsentHistoryFilterComponent implements OnInit {
  vendors = [];
  banks = [];
  fipList = [];
  fiuList = [];
  statusList = [];
  selectedVendor: any; 
  selectedFip: any;
  selectedStatus: any
  fromDate:any;
  toDate:any;

  @Output() appliedHistoryFilters = new EventEmitter();

  constructor(
    private commonService : CommonService,
  ) {}
  ngOnInit() {
      this.getFiuList();
      this.getFipList();

      this.statusList = [
        {
          label: "ACTIVE",
          value: "ACTIVE"
        }, {
          label: "PENDING",
          value: "PENDING"
        }, {
          label: "DECLINED",
          value: "DECLINED"
        }, {
          label: "EXPIRED",
          value: "EXPIRED"
        }, {
          label: "REVOKED",
          value: "REVOKED"
        }
      ]
  }

  generateFIPDropDownData() {
    this.fipList.forEach(element => {
      let fip = {
        label: element.fipName,
        value: element
      }
      this.banks.push(fip);
    });
  }

  generateFIUDropDownData() {
    this.fiuList.forEach(element => {
      let fiu = {
        label: element.name,
        value: element
      }
      this.vendors.push(fiu);
    });
  }


  getFipList(){
    this.commonService.getFIPList().subscribe(res => {
        this.fipList = res;
        this.generateFIPDropDownData();
    });
  }

  getFiuList(){
    this.commonService.getFIUList().subscribe(res => {
        this.fiuList = res;
        this.generateFIUDropDownData();
    });
  }

  applyFilters() {
    let vendorId = this.selectedVendor ? this.selectedVendor.id : null
    let filterObj = {
      fiuId: vendorId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      status: this.selectedStatus,
    }
    this.appliedHistoryFilters.emit(filterObj)
  }

  resetFilters() {
    this.selectedVendor = null; 
    this.selectedFip = null;
    this.selectedStatus = null;
    this.fromDate = "";
    this.toDate = "";
  }

  cancelFilters() {
    this.resetFilters();
    this.appliedHistoryFilters.emit({})
  }

}
